// TODO mutualiser les deux interfaces ci-dessous lorsque les retours de l'api seront unifiés
import {Step} from '../types/Stepper';

export interface ListOrder {
    id: string;
    service: string | null;
    serviceId: number | null;
    site: string | null;
    status: Step | null;
    opening: string | null;
    system: 'DESK' | 'CIS';
    siteId: number | null;
}

export interface DetailedOrder {
    id: string;
    status: Step | null;
    description: string | null;
    rate: number | null;
    deposit: string | null;
    grt: string | null;
    commitment: string | null;
    mesExpectedDate: string | null;
    mesContractDate: string | null;
}

export enum OrderStatus {
    ISSUED,
    IN_PROGRESS,
    CANCELED,
    CLOSED,
    IN_PRODUCTION,
    PENDING_CLOSING,
}

type OrderMessageType = 'reply' | 'message';

export interface OrderMessage {
    sender: string;
    content: string;
    time: string;
    type: OrderMessageType;
}
